import React from 'react'

// ReactorUi
import { Box, Flex } from 'reactor-ui'
import * as RV from 'reactor-vera/templates/v1'


const BankPayments = props => {
  return (
    <RV.Routes>
      <RV.Route path='/' element={(
        <RV.GraphTable
          modelName={'BankPaymentOperation'}
          query={{
            filters: {
              // status: 'DONE'
            }
          }}
          detailLink={'d'}
        />
      )} />
      <RV.Route path='d/:bankPaymentOperationId/*' element={<BankPaymentDetail />} />
    </RV.Routes>
  )
}

const BankPaymentDetail = props => {
  return (
    <RV.EntityDetailPage
      modelName='BankPaymentOperation'
      routes={[
        (entity, result) => (
          <RV.Route path='/' element={(
            <Box>
              <RV.GraphTable
                modelName={'BankPaymentResource'}
                query={{
                  filters: {
                    bank_payment_operation_id: entity.id
                  }
                }}
              />
            </Box>
          )} />
        )
      ]}
    />
  )
}

export default BankPayments